"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.RevalPrj = void 0;
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _RowEval = require("./RowEval");
var RevalPrj = /*#__PURE__*/function () {
  function RevalPrj() {
    (0, _classCallCheck2["default"])(this, RevalPrj);
  }
  (0, _createClass2["default"])(RevalPrj, null, [{
    key: "reval",
    value: function () {
      var _reval2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(prj, progressFunc) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", RevalPrj._reval(prj, progressFunc));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function reval(_x, _x2) {
        return _reval2.apply(this, arguments);
      }
      return reval;
    }()
  }, {
    key: "_reval",
    value: function () {
      var _reval3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(prj, progressFunc) {
        var _context2, _context3;
        var graphic,
          price,
          bom,
          rows,
          _context4,
          noEvalRows,
          _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              graphic = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : true;
              price = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : false;
              bom = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : false;
              rows = (0, _filter["default"])(_context2 = prj.rows).call(_context2, function (r) {
                if (!r.auto && !r.local) r.jeval3ddone = false;
                return !r.auto && !r.local;
              });
              (0, _forEach["default"])(_context3 = prj.rows).call(_context3, function (r) {
                r.jeval3ddone = false;
              });
              if (progressFunc) {
                noEvalRows = (0, _filter["default"])(_context4 = prj.rows).call(_context4, function (r) {
                  return !r.jeval3ddone && !r.auto && !r.local;
                });
                progressFunc((rows.length - noEvalRows.length) / rows.length);
              }
              return _context5.abrupt("return", rows.length > 0 ? RevalPrj._revalRows(rows, progressFunc, graphic, price, bom) : new _promise["default"](function (resolve, reject) {
                resolve(null);
              }));
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee2);
      }));
      function _reval(_x3, _x4) {
        return _reval3.apply(this, arguments);
      }
      return _reval;
    }()
  }, {
    key: "_revalRows",
    value: function () {
      var _revalRows2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(rows, progressFunc) {
        var graphic,
          price,
          bom,
          noEvalRows,
          row,
          _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              graphic = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : true;
              price = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : false;
              bom = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : false;
              noEvalRows = (0, _filter["default"])(rows).call(rows, function (r) {
                return !r.jeval3ddone && !r.auto && !r.local;
              });
              row = noEvalRows[0];
              return _context6.abrupt("return", new _promise["default"](function (resolve, reject) {
                _RowEval.RowEval.evalRow(row, -1, true, graphic, price, bom)["finally"](function () {
                  noEvalRows = (0, _filter["default"])(rows).call(rows, function (r) {
                    return !r.jeval3ddone && !r.auto && !r.local;
                  });
                  if (progressFunc) progressFunc((rows.length - noEvalRows.length) / rows.length);
                  if (noEvalRows.length > 0) {
                    RevalPrj._revalRows(rows, progressFunc, graphic, price, bom)["catch"](function (err) {
                      console.error(err);
                    })["finally"](function () {
                      return resolve(null);
                    });
                  } else {
                    resolve(null);
                  }
                })["catch"](function (err) {
                  console.error(err, row);
                  row.jeval3ddone = true;
                });
              }));
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee3);
      }));
      function _revalRows(_x5, _x6) {
        return _revalRows2.apply(this, arguments);
      }
      return _revalRows;
    }()
  }]);
  return RevalPrj;
}();
exports.RevalPrj = RevalPrj;
//# sourceMappingURL=RevalPrj.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/controllers/RevalPrj.js
// module id = 1255
// module chunks = 142